module.exports = __webpack_public_path__ + "static/media/google-play-word-best-indie-game@2x.9b51ecfc.png";